export default __webpack_public_path__ + "fonts/montserrat-lightitalic-webfont.woff";